import React from 'react';
import { C, LAYOUT } from '../../shared/design-tokens.js';
import { vehicleStatusPresentation } from './fleet-ui.js';
import type { FleetVehicle } from './use-fleet-read-model.js';

interface FleetIssuesPanelProps {
  vehiclesWithIssues: FleetVehicle[];
  totalOpenIssues: number;
}

export default function FleetIssuesPanel({ vehiclesWithIssues, totalOpenIssues }: FleetIssuesPanelProps) {
  if (totalOpenIssues === 0) {
    return (
      <div style={LAYOUT.subPanel}>
        <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.08em', color: C.gold, marginBottom: 12 }}>
          Issues / maintenance read seam
        </div>
        <div style={{ color: C.green, fontSize: 13 }}>No open issues — fleet is clear ✓</div>
      </div>
    );
  }

  return (
    <div style={LAYOUT.subPanel}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
        <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.08em', color: C.gold }}>
          Issues / maintenance read seam
        </div>
        <div style={{ fontSize: 13, color: C.red, fontWeight: 700 }}>
          {totalOpenIssues} open issue{totalOpenIssues !== 1 ? 's' : ''} across {vehiclesWithIssues.length} vehicle{vehiclesWithIssues.length !== 1 ? 's' : ''}
        </div>
      </div>

      <div style={{ display: 'grid', gap: 10 }}>
        {vehiclesWithIssues
          .slice()
          .sort((a: FleetVehicle, b: FleetVehicle) => (b.issue_count || 0) - (a.issue_count || 0))
          .map((vehicle: FleetVehicle) => {
            const status = vehicleStatusPresentation(vehicle.current_status || '');
            return (
              <div key={vehicle.id} style={{ padding: 12, borderRadius: 10, background: C.panel, border: `1px solid rgba(255,107,107,0.3)` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', alignItems: 'center', marginBottom: 6 }}>
                  <div>
                    <span style={{ color: C.text, fontSize: 14, fontWeight: 700 }}>#{vehicle.truck_number || '—'}</span>
                    <span style={{ color: C.textMuted, fontSize: 12, marginLeft: 8 }}>{vehicle.terminal_name || vehicle.current_terminal_name || 'No terminal'}</span>
                  </div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                    <span style={{ fontSize: 11, padding: '3px 10px', borderRadius: 999, color: status.color, background: status.background }}>
                      {status.label}
                    </span>
                    <span style={{ fontSize: 12, fontWeight: 700, color: C.red }}>
                      {vehicle.issue_count} open issue{vehicle.issue_count !== 1 ? 's' : ''}
                    </span>
                  </div>
                </div>
                {vehicle.current_status === 'oos' && (
                  <div style={{ color: C.red, fontSize: 12 }}>⚠ Out of service — may require maintenance before return to active duty</div>
                )}
                {vehicle.current_status !== 'oos' && (vehicle.issue_count || 0) >= 3 && (
                  <div style={{ color: C.gold, fontSize: 12 }}>⚠ Multiple open issues — review for OOS eligibility</div>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}
